import React, { Component } from 'react';
import { MdTextsms, MdPhoneAndroid, MdStar } from 'react-icons/md';
import { FaRupeeSign, FaHashtag } from "react-icons/fa";
import { IoIosPaper } from "react-icons/io";
import { ClickableIcon } from '../oro-module/ajaxdata';

// Auto refresh the data every 10 minutes & show the timer in the background. Also show sync button.

const createSubDataFollowpList = (subData, subd = true) => {
  let cnt = 0;
  let isphone = subData.phone ? 1 : 0;
  let wdt = "col-sm-6";
  if (Object.keys(subData).length - isphone == 1) {
    wdt = "col-sm-12";
  }
  return (
    <div className="row">
      {Object.keys(subData).map((key, idx) => {
        if (key == 'ac' && subd) {
          cnt += 1;
          return <div key={idx} className={cnt == 1 ? wdt : "col-sm-6 right"}>Ac: {subData[key]} </div>;
        }
        else if (key == 'currency' && subd) {
          cnt += 1;
          return <div key={idx} className={cnt == 1 ? wdt : "col-sm-6 right"}>{subData[key]} </div>;
        }
        else if (key == 'offer' && subd) {
          cnt += 1;
          return <div key={idx} className={cnt == 1 ? wdt : "col-sm-6 right"}><MdStar />&nbsp;{subData[key]} </div>;
        }
        else if (key == 'docs' && subd) {
          cnt += 1;
          return <div key={idx} className={cnt == 1 ? wdt : "col-sm-6 right"}><IoIosPaper />&nbsp;{subData[key]} </div>;
        } else if (key != 'phone') {
          cnt += 1;
          return <div key={idx} className={cnt == 1 ? wdt : "col-sm-6 right"}>{subData[key]} </div>;
        }
      })}
    </div>
  )
}

const FollowupListRecord = ({ main, sub, current }) => {
  return (
    <div className="row followuplist">
      <div className="col-sm-10 title">
        {main.desc}&nbsp;{sub.desc.phone ? `(${sub.desc.phone})` : ""}
      </div>
      <div className="col-sm-2 right">
        <ClickableIcon action="sendfollowupsms" icon="sms" current={current} style={{ color: "#55ACEE" }} />
      </div>
      <div className="col-sm-12 sub-title">{createSubDataFollowpList(sub.desc)}</div>
      <div className="col-sm-12"><hr style={{ margin: 0 }}></hr></div>
    </div>
  );
}

class FollowupList extends Component {

  render() {
    let { values } = this.props.component;
    return (
      <div
        className={`form-group nopadding ${this.props.component.widths.parent}`}
      >
        {
          values.map(({ main, sub }, idx) => {
            return (
              <div key={idx} className="fl-rec">
                {/* <div className="col-sm-12"> */}
                <FollowupListRecord main={main} sub={sub} current={this} />
                {/* </div> */}
              </div>
            )
          })
        }
      </div>
    );
  }
}

export default FollowupList;